import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputComponent } from '../../../common/components/form-components/input/input';
import { Dropdown } from '../../../common/components/form-components/dropdown/dropdown';
import { CardModule } from 'primeng/card';
import { Button } from '../../../common/components/form-components/button/button';
import { Router } from '@angular/router';
import { StepsModule } from 'primeng/steps';
import { Password } from '../../../common/components/form-components/password/password';
import { SignupService } from '../../services/signup-service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { TranslateService } from '../../../i18n/translate.service';

@Component({
  selector: 'app-create-account',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    InputComponent,
    Dropdown,
    CardModule,
    Button,
    StepsModule,
    Password,
  ],
  templateUrl: './create-account.html',
  styleUrl: './create-account.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CreateAccount implements OnInit, OnDestroy {
  @Output() onSubmit = new EventEmitter<any>();
  CreateAccountForm: any;
  countries: any = [];
  private sessionStorageKey = 'employeeDetails';
  submitted: boolean = false;
  businessLocation: any;
  selectedCountry: any;
  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private mSignupService: SignupService,
    private cdr: ChangeDetectorRef,
    readonly i18n: TranslateService
  ) {
    this.CreateAccountForm = this.fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      countries: ['', [Validators.required]],
      mobile: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      remember: [false],
    });
  }
  ngOnInit(): void {
    this.getCountries();
  }

  // getCountries() {
  //   this.mSignupService.GetCountries().subscribe((res: any) => {
  //     res.data.map((country: any) => {
  //       this.countries.push({ name: country.value, code: country.code, id: country.id });
  //       this.mSignupService.countries = this.countries;
  //       this.businessLocation = this.mSignupService.countries;
  //       console.log("sachin", this.businessLocation);
  //     });
  //   });
  // }

  getCountries() {
    this.mSignupService.GetCountries().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      const formattedCountries = res.data.map((country: any) => ({
        name: country.name,
        code: country.code,
        id: country.id,
        phoneCode: country.phoneCode
      }));
      this.countries = formattedCountries;
      this.mSignupService.countries = this.countries;
      this.businessLocation = this.countries;
      this.restoreFormValues();
      this.cdr.detectChanges();
    });
  }

  onCountryChange(countryId: any) {
    this.selectedCountry = this.countries.find((c: any) => c.id === countryId);
  }

  restoreFormValues() {
    const savedData = sessionStorage.getItem(this.sessionStorageKey);
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        this.CreateAccountForm.patchValue(parsedData);
        if (parsedData.countries) {
          this.onCountryChange(parsedData.countries);
        }
      } catch (error) {
        console.error('Invalid session data:', error);
      }
    }
  }

  onLogin() {
    this.submitted = true;

    if (this.CreateAccountForm.valid) {
      this.storeFormData();
      this.onSubmit.emit();
    } else {
      this.CreateAccountForm.markAllAsDirty();
      this.CreateAccountForm.updateValueAndValidity({ emitEvent: true });
    }
  }

  storeFormData() {
    const formData = this.CreateAccountForm.value;
    formData.phoneCode = this.selectedCountry?.phoneCode;
    sessionStorage.setItem(this.sessionStorageKey, JSON.stringify(formData));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
